import { Box, Button, ButtonGroup, Card, Grid, Icon } from "@mui/material";
import PropTypes from "prop-types";

import InspectionTimeline from "modules/inspections/components/InspectionTimeline";
import SoftBox from "components/SoftComponents/SoftBox";
import SoftButton from "components/SoftComponents/SoftButton";
import { useMatch, useNavigate } from "react-router-dom";
import SoftTypography from "components/SoftComponents/SoftTypography";
import { wrapper } from "utils/wrapper";
import { deviceViewWrapper } from "utils/wrapper";
import { useState } from "react";

import inspectionAPI from "modules/inspections/api";
import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from "@tanstack/react-query";
import moment from "moment";
import { disableMap } from "utils/map";
import { useSoftUIController } from "hooks/context";

import Demo1 from "assets/images/demo/demo_1.png";
import Demo2 from "assets/images/demo/demo_2.png";
import Demo3 from "assets/images/demo/StationLink_ePaper_Lillian_Ave_stops.png";
import Divider from "@material-ui/core/Divider";
import { PhotoProvider, PhotoView } from "react-photo-view";
import SoftBadge from "components/SoftComponents/SoftBadge";
import SoftInput from "components/SoftComponents/SoftInput";
import { Search } from "@mui/icons-material";
import SoftTagInput from "components/SoftComponents/SoftTagInput";
import CampaignEdit from "pages/components/Campaigns/CampaignEdit";

function DeviceCampaignsTab({ uuid, device, deviceLayout }) {

    const [showTypes, setShowTypes] = useState({ bk_poster: true, closure: true, takeover: false });
    const [viewedCampaign, setViewedCampaign] = useState(null);

    const demo = [{
        name: "Salisbury 9 Dec",
        timing: "Always Showing",
        color: "secondary",
        status: "Disabled",
        img: Demo1,
    },
    {
        name: "BNBN Poster",
        timing: "From: Mon 2/06/25 05:00",
        timing2: "Until: Sun 20/07/25 22:00",
        color: "dark",
        status: "Inactive",
        img: Demo2,
    },
    {
        name: "Salisbury Station Reopening",
        timing: "From: Mon 23/02/26, 00:00 to 23:59",
        color: "success",
        status: "Active",
        img: Demo3,
    }];

    const [tags, setTags] = useState([`STOP ${device.stop.stop_id}`]);

    const currentCampaigns = (
        <SoftBox borderRadius="20px" color={"white"} width="100%" height={deviceLayout == 'mobile' ? "calc(100svh - 9rem - 16px)" : "calc(100svh - 10.25rem - 16px)"} sx={({ palette: { white }, functions: { rgba } }) => ({ backgroundColor: rgba(white.main, 0.6), overflow: 'hidden' })}>
            <SoftBox display="flex" flexDirection="column" borderRadius="10px" color={"white"} width="100%" height="100%" sx={({ functions: { rgba } }) => ({ backgroundColor: rgba("#eeeeee", 1) })}>
                <SoftBox p={1} sx={({ functions: { rgba } }) => ({ borderRadius: '10px 10px 0 0', backgroundColor: rgba("#dcdcdc", 1), borderBottom: "1px solid #8e98a5" })}>
                    <SoftBox p={1} display="flex" flexDirection="column">
                        <SoftBox mb={0.5} pl={0.5}>
                            <SoftTypography variant="caption" fontWeight="bold">
                                Tags
                            </SoftTypography>
                        </SoftBox>
                        <SoftBox display="flex" flexDirection="row" width="100%">
                            <SoftTagInput
                                tags={tags}
                                size="large"
                                placeholder=" "
                                onChange={(newSkill) => setTags(newSkill)}
                                removeOnBackspace
                            />
                        </SoftBox>
                        <SoftBox mt={2} mb={0.5} pl={0.5}>
                            <SoftTypography variant="caption" fontWeight="bold">
                                Campaign Types
                            </SoftTypography>
                        </SoftBox>
                        <SoftBox display="flex" flexDirection="row">
                            <SoftBox display="inline-flex" borderRadius="lg" pr={0.5}>
                                <ButtonGroup variant="gradient" color="dark" size="medium">
                                    <SoftButton onClick={() => setShowTypes({ ...showTypes, bk_poster: !showTypes.bk_poster })} sx={{ backgroundColor: showTypes.bk_poster ? "#fff !important" : "#e7e7e7 !important", fontSize: '14px', textTransform: "none", fontWeight: "regular" }}>BK ePaper Poster</SoftButton>
                                    <SoftButton
                                        circular={false}
                                        sx={{
                                            px: 2,
                                            backgroundColor: showTypes.bk_poster ? "#fff !important" : "#e7e7e7 !important",
                                            color: "#627594 !important",
                                            borderTopLeftRadius: 0,
                                            borderBottomLeftRadius: 0,
                                            borderLeft: "1px solid rgba(0,0,0,0.1)",
                                            "&:hover": {
                                                backgroundColor: "#f8f9fa !important",
                                            }
                                        }}
                                    >
                                        <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                                    </SoftButton>
                                </ButtonGroup>
                            </SoftBox>
                            <SoftBox display="inline-flex" borderRadius="lg" px={0.5}>
                                <ButtonGroup variant="gradient" color="dark" size="medium">
                                    <SoftButton onClick={() => setShowTypes({ ...showTypes, closure: !showTypes.closure })} sx={{ backgroundColor: showTypes.closure ? "#fff !important" : "#e7e7e7 !important", fontSize: '14px', textTransform: "none", fontWeight: "regular" }}>Closure Poster</SoftButton>
                                    <SoftButton
                                        circular={false}
                                        sx={{
                                            px: 2,
                                            backgroundColor: showTypes.closure ? "#fff !important" : "#e7e7e7 !important",
                                            color: "#627594 !important",
                                            borderTopLeftRadius: 0,
                                            borderBottomLeftRadius: 0,
                                            borderLeft: "1px solid rgba(0,0,0,0.1)",
                                            "&:hover": {
                                                backgroundColor: "#f8f9fa !important",
                                            }
                                        }}
                                    >
                                        <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                                    </SoftButton>
                                </ButtonGroup>
                            </SoftBox>
                            <SoftBox display="inline-flex" borderRadius="lg" px={0.5}>
                                <ButtonGroup variant="gradient" color="dark" size="medium">
                                    <SoftButton onClick={() => setShowTypes({ ...showTypes, takeover: !showTypes.takeover })} sx={{ backgroundColor: showTypes.takeover ? "#fff !important" : "#e7e7e7 !important", fontSize: '14px', textTransform: "none", fontWeight: "regular" }}>Takeover Poster</SoftButton>
                                    <SoftButton
                                        circular={false}
                                        sx={{
                                            px: 2,
                                            backgroundColor: showTypes.takeover ? "#fff !important" : "#e7e7e7 !important",
                                            color: "#627594 !important",
                                            borderTopLeftRadius: 0,
                                            borderBottomLeftRadius: 0,
                                            borderLeft: "1px solid rgba(0,0,0,0.1)",
                                            "&:hover": {
                                                backgroundColor: "#f8f9fa !important",
                                            }
                                        }}
                                    >
                                        <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                                    </SoftButton>
                                </ButtonGroup>
                            </SoftBox>
                        </SoftBox>
                    </SoftBox>
                </SoftBox>
                <SoftBox height="auto" sx={{ overflowY: 'auto' }} p={2}>
                    {showTypes.bk_poster && (
                        <SoftBox pb={'48px'}>
                            <SoftBox display="flex" alignItems="center" width="100%" pb={2}>
                                <SoftTypography variant="button" fontWeight="medium" sx={{ fontSize: '16px', whiteSpace: "nowrap", pr: 2 }}>
                                    BK ePaper Poster
                                </SoftTypography>

                                <SoftBox flex={1}>
                                    <Divider style={{ opacity: 1 }} />
                                </SoftBox>
                            </SoftBox>
                            <SoftBox>
                                <Grid container spacing={1}>
                                    {demo.map((opt, index) => (
                                        <Grid item key={index} xxs={12} md={6} xl={4} x3l={3} x5l={2}>

                                            <PhotoProvider key={index}>
                                                <Card sx={{ height: '100%', boxShadow: opt.color == "success" && "0 0 15px 2px rgba(51, 255, 0, 0.3)" }}>
                                                    <SoftBox p={2} height="100%">
                                                        <PhotoView src={opt.img}>
                                                            <SoftBox
                                                                component="img"
                                                                src={opt.img}
                                                                width="100%"
                                                                height="300px"
                                                                sx={{
                                                                    objectFit: 'scale-down',
                                                                    borderRadius: '5px',
                                                                    cursor: 'pointer',
                                                                    transition: "box-shadow 0.3s ease-in-out",
                                                                    "&:hover": {
                                                                        boxShadow: "0 0 15px 2px rgba(0, 0, 0, 0.3)",
                                                                    }
                                                                }}
                                                            />
                                                        </PhotoView>
                                                        <SoftBox pt={2} pb={1}>
                                                            <Divider />
                                                        </SoftBox>
                                                        <SoftBox width="100%" pb={1}>
                                                            <SoftBadge variant="gradient" color={opt.color} badgeContent={opt.status} container sx={{ display: 'block', width: '100% !important' }} />
                                                        </SoftBox>
                                                        <SoftBox p={1} display="flex" flexDirection='column' sx={{ borderRadius: '10px', backgroundColor: '#eee' }}>
                                                            <SoftTypography variant="button" sx={{ fontSize: '18px' }}>{opt.name}</SoftTypography>
                                                            {opt?.timing2 ? (
                                                                <>
                                                                    <SoftTypography variant="caption" sx={{ fontSize: '14px' }}>{opt.timing}</SoftTypography>
                                                                    <SoftTypography variant="caption" sx={{ fontSize: '14px' }}>{opt.timing2}</SoftTypography>
                                                                </>
                                                            ) : (
                                                                <SoftTypography variant="caption" sx={{ fontSize: '14px', lineHeight: '2.5' }}>{opt.timing}</SoftTypography>
                                                            )}
                                                        </SoftBox>
                                                        <SoftBox pt={1} pb={2}>
                                                            <Divider />
                                                        </SoftBox>
                                                        <SoftBox>
                                                            <Grid container spacing={1}>
                                                                <Grid item xxs={12} sm={4}>
                                                                    <SoftButton variant="gradient" color="dark" size="small" fullWidth onClick={() => setViewedCampaign({ ...opt, tags })}>
                                                                        <Icon sx={{ paddingBottom: '3px', paddingRight: '5px' }}>settings</Icon>
                                                                        Edit
                                                                    </SoftButton>
                                                                </Grid>
                                                                <Grid item xxs={12} sm={4}>
                                                                    <SoftButton variant="gradient" color="dark" size="small" fullWidth>
                                                                        <Icon sx={{ paddingBottom: '3px', paddingRight: '5px' }}>power_settings_new</Icon>
                                                                        Enable
                                                                    </SoftButton>
                                                                </Grid>
                                                                <Grid item xxs={12} sm={4}>
                                                                    <SoftButton variant="gradient" color="dark" size="small" fullWidth>
                                                                        <Icon sx={{ paddingBottom: '3px', paddingRight: '5px' }}>delete</Icon>
                                                                        Delete
                                                                    </SoftButton>
                                                                </Grid>
                                                            </Grid>
                                                        </SoftBox>
                                                    </SoftBox>
                                                </Card>
                                            </PhotoProvider>
                                        </Grid>
                                    ))}
                                </Grid>
                            </SoftBox>
                        </SoftBox>
                    )}
                    {showTypes.closure && (
                        <SoftBox pb={'48px'}>
                            <SoftBox display="flex" alignItems="center" width="100%" pb={2}>
                                <SoftTypography variant="button" fontWeight="medium" sx={{ fontSize: '16px', whiteSpace: "nowrap", pr: 2 }}>
                                    Closure Poster
                                </SoftTypography>

                                <SoftBox flex={1}>
                                    <Divider sx={{ backgroundColor: "#000", opacity: 1 }} />
                                </SoftBox>
                            </SoftBox>
                            <SoftBox>
                                <SoftTypography variant="caption" sx={{ fontSize: "15px" }}>
                                    No Campaigns Found
                                </SoftTypography>
                            </SoftBox>
                        </SoftBox>
                    )}
                    {showTypes.takeover && (
                        <SoftBox pb={'48px'}>
                            <SoftBox display="flex" alignItems="center" width="100%" pb={2}>
                                <SoftTypography variant="button" fontWeight="medium" sx={{ fontSize: '16px', whiteSpace: "nowrap", pr: 2 }}>
                                    Takeover Poster
                                </SoftTypography>

                                <SoftBox flex={1}>
                                    <Divider sx={{ backgroundColor: "#000", opacity: 1 }} />
                                </SoftBox>
                            </SoftBox>
                            <SoftBox>
                                <SoftTypography variant="caption" sx={{ fontSize: "15px" }}>
                                    No Campaigns Found
                                </SoftTypography>
                            </SoftBox>
                        </SoftBox>
                    )}
                </SoftBox>
            </SoftBox>
        </SoftBox>
    );

    if (viewedCampaign != null) {
        return <CampaignEdit device={device} content_id={""} viewedCampaign={viewedCampaign} setViewedCampaign={setViewedCampaign} />
    }
    else {
        return currentCampaigns;
    }
}

DeviceCampaignsTab.propTypes = {
    uuid: PropTypes.string,
    device: PropTypes.object,
    deviceLayout: PropTypes.string,
}

export default DeviceCampaignsTab;